import React, { memo } from 'react';
import { Typography, TypographyProps } from '@material-ui/core';

interface Props extends TypographyProps {
  value?: string | string[];

  disableTypography?: boolean;
}

/**
 *
 * @param value The value to convert
 * @param separator Defaults to ' '
 * @returns String value parsed to be human readable
 */
export function EnumValueHumanizer(value: string | string[], separator: string = ' ') {
  const list = Array.isArray(value) ? value : [value];
  return list
    .map(val =>
      val
        .split(/[_\-]/) // first split on underscores/hyphens
        .flatMap(part =>
          part
            .split(/((?<=[a-z])(?=[A-Z])(?![A-Z][a-z])|(?=[A-Z](?=[a-z])))/)
            ?.filter(s => s !== '')
        )
        .join(separator)
    )
    .join(', ');
}

export const EnumValueDisplay: React.FC<Props> = memo(({ value, disableTypography, ...props }) => {
  if (!value) return null;

  const formatted = EnumValueHumanizer(value);

  if (disableTypography) return <>{formatted}</>;

  return <Typography {...props}>{formatted}</Typography>;
});
